// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__3iNQd","p0Login":"styles_p0Login__3jbEY","modal":"styles_modal__o2V3y","modalContent":"styles_modalContent__1kYDJ"};